import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import * as format from "../../common/FormatFunctions";

export class ListValueGenerator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: [],
      imageUriList: this.props.currentImages,
      currentListProperty: "",
      sequenceAdded: false
    };

    this.logger = Log;
  }

  addAcceptedProperty = () => {
    var property = this.state.currentListProperty;
    if (format.isNotNull(this.props.appendValue)) {
      property = property + this.props.appendValue;
    }
    var currentList = this.props.listProperties;
    if (currentList === undefined || currentList === null) {
      currentList = [];
    } else {
    }
    this.logger.info(currentList);

    if (this.props.defaults === true) {
      currentList.splice(currentList.length - 2, 0, property);
    } else {
      currentList.push(property);
    }

    this.logger.info(currentList);
    this.props.updateBean(this.props.listField, currentList);
    this.setState({ currentListProperty: "" });
  };

  removeAcceptedProperty = value => {
    var currentList = this.props.listProperties;
    this.logger.info(currentList);
    if (currentList === undefined || currentList === null) {
      currentList = [];
    } else {
      this.logger.info(value);
      if (this.props.type === "DROPDOWN") {
        this.props.selectionOptions.forEach(element => {
          if (element.value === value) {
            value = element.label;
          }
        });
      }
      currentList = currentList.filter(item => item !== value);
    }

    this.logger.info(currentList);
    this.props.updateBean(this.props.listField, currentList);
    this.setState({ currentListProperty: "" });
  };

  reorderSequence = e => {
    Log.error(e);
    var changedList = [];
    if (format.isNotNull(e.value)) {
      e.value.forEach(element => {
        changedList.push(element.value);
      });
    }
    this.props.updateBean(this.props.listField, changedList);
  };

  render() {
    return (
      <React.Fragment>
        <label className="input-label">{this.props.title}</label>
        <div className="ui-g-12">
          <div className="ui-g-6">{this.getInputType()}</div>

          <div className="ui-g-6">
            <pr.Button
              icon="pi pi-plus"
              onClick={() => {
                this.addAcceptedProperty();
              }}
              style={{ marginRight: ".25em", background: "green" }}
            />
          </div>
        </div>
        <div className="ui-g-12">{this.getCustomValuesTable()}</div>
      </React.Fragment>
    );
  }

  getInputType = () => {
    if (this.props.type === "DROPDOWN") {
      this.logger.info(this.props.selectionOptions);
      return (
        <pr.Dropdown
          placeholder={this.props.header}
          value={this.state.currentListProperty || ""}
          options={this.props.selectionOptions}
          style={{ width: "100%" }}
          onChange={e => this.setState({ currentListProperty: e.value })}
        />
      );
    } else {
      return (
        <pr.InputText
          style={{ width: "100%" }}
          placeholder={this.props.header}
          value={this.state.currentListProperty || ""}
          onChange={e => this.setValue(e.target.value)}
          onKeyPress={this.handleKeyPress}
        />
      );
    }
  };

  handleKeyPress = event => {
    if (event.key === "Enter") {
      console.log(event);
      this.addAcceptedProperty();
    }
  };

  setValue = value => {
    if (this.props.capitalize) {
      this.setState({ currentListProperty: value.toUpperCase() });
    } else {
      this.setState({ currentListProperty: value });
    }
  };
  getCustomValues = () => {
    let componentArray = [];
    let i = 0;

    // var totalNumberOfAttributes = temporaryAttributSet1.length;
    // var splitInto = 0;
    // var uigno = 0;
    // if (totalNumberOfAttributes % 3 === 0) {
    //   splitInto = 3;
    //   uigno = 4;
    // } else {
    //   splitInto = 2;
    //   uigno = 6;
    // }

    if (this.props.listProperties !== undefined) {
      this.logger.info(this.props.listProperties);
      var array = this.props.listProperties;
      array.forEach(e => {
        componentArray[i] = (
          <div className="ui-g-4 card" key={i} style={{ paddingTop: "2em" }}>
            <div>
              <label style={{ float: "middle" }}>
                {this.props.propertyPrefix} {e}
              </label>
              {this.props.defaults === true &&
              (i === 0 || i === array.length - 1) ? (
                <label></label>
              ) : (
                <pr.Button
                  align="right"
                  icon="pi pi-times"
                  className="p-button-danger"
                  style={{ float: "right" }}
                  onClick={() => {
                    this.removeAcceptedProperty(e);
                  }}
                />
              )}
            </div>
          </div>
        );

        i++;
      });
    }

    return componentArray;
  };

  getCustomValuesTable = () => {
    if (this.props.includeSequence) {
      return this.getCustomValuesTableSequenced();
    } else {
      return this.getCustomValuesTableUnsequenced();
    }
  };
  getCustomValuesTableUnsequenced = () => {
    if (format.isNotNull(this.props.defaultValues)) {
      if (format.isNotNull(this.props.listProperties)) {
      } else {
        this.props.updateBean(this.props.listField, this.props.defaultValues);
      }
    }
    if (this.props.listProperties !== undefined) {
      return (
        <div className="ui-g-12" style={{ paddingTop: "2em" }}>
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={e => {}}
            value={this.props.listProperties}
            dataKey="id"
            emptyMessage="No Properties"
            // header={
            //   <div>
            //     <label className="header-label">Accepted Values</label>
            //   </div>
            // }
            rows={100}
            autoLayout={true}
            style={{ borderColor: "transparent" }}
          >
            <pr.Column
              header={<label className="input-label">Options</label>}
              body={this.valueTemplate}
              style={{ overflow: "auto", background: "white" }}
            />
            <pr.Column
              key="add"
              body={this.getPropertyRemoveTemplate}
              style={{ textAlign: "center", background: "white", width: "8em" }}
            />
          </pr.DataTable>{" "}
        </div>
      );
    } else {
      return <div></div>;
    }
  };
  getCustomValuesTableSequenced = () => {
    if (format.isNotNull(this.props.defaultValues)) {
      if (format.isNotNull(this.props.listProperties)) {
      } else {
        this.props.updateBean(this.props.listField, this.props.defaultValues);
      }
    }
    if (this.props.listProperties !== undefined) {
      var index = 1;
      var sequencedList = [];
      this.props.listProperties.forEach(element => {
        sequencedList.push({ sequence: index, value: element });
        index++;
      });

      return (
        <div className="ui-g-12" style={{ paddingTop: "2em" }}>
          <pr.DataTable
            ref={el => {
              this.dt = el;
            }}
            reorderableColumns={false}
            selectionMode="single"
            onSelectionChange={e => {}}
            value={sequencedList}
            dataKey="id"
            emptyMessage="No Properties"
            // header={
            //   <div>
            //     <label className="header-label">Accepted Values</label>
            //   </div>
            // }
            rows={100}
            autoLayout={true}
            style={{ borderColor: "transparent" }}
            // reorderableRows={true}
            // onRowReorder={e => this.reorderSequence(e)}
          >
            {/* <pr.Column
              rowReorder={true}
              rowReorderIcon="pi pi-list"
              style={{
                width: "3em",
                float: "middle",
                cursor: "move"
              }}
            /> */}

            <pr.Column
              header={<label className="input-label">Accepted Value</label>}
              body={this.valueTemplateSequenced}
              style={{ overflow: "auto", background: "white" }}
            />

            <pr.Column
              key="add"
              header={<label className="input-label">Sequence</label>}
              body={this.sequenceTemplate}
              style={{ textAlign: "center", background: "white", width: "8em" }}
            />

            <pr.Column
              key="add"
              body={this.getPropertyRemoveTemplateSequenced}
              style={{ textAlign: "center", background: "white", width: "8em" }}
            />
          </pr.DataTable>{" "}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  valueTemplate = (rowData, column) => {
    return (
      <label className="input-label" style={{ float: "middle" }}>
        {" "}
        {rowData}{" "}
      </label>
    );
  };
  valueTemplateSequenced = (rowData, column) => {
    return (
      <label className="input-label" style={{ float: "middle" }}>
        {" "}
        {rowData.value}{" "}
      </label>
    );
  };

  sequenceTemplate = (rowData, column) => {
    return (
      <label className="input-label" style={{ float: "middle" }}>
        {" "}
        {rowData.sequence}{" "}
      </label>
    );
  };
  getPropertyRemoveTemplate = (rowData, column) => {
    if (format.isNotNull(this.props.defaultValues)) {
      if (this.props.defaultValues.includes(rowData)) {
        return <div></div>;
      }
    }

    return (
      <div>
        <pr.Button
          align="right"
          icon="pi pi-times"
          className="p-button-danger"
          style={{ background: "red" }}
          onClick={() => {
            this.removeAcceptedProperty(rowData);
          }}
        />
      </div>
    );
  };
  getPropertyRemoveTemplateSequenced = (rowData, column) => {
    if (format.isNotNull(this.props.defaultValues)) {
      if (!this.props.allowDefaultDelete) {
        if (this.props.defaultValues.includes(rowData.value)) {
          return <div></div>;
        }
      }
    }

    return (
      <div>
        <pr.Button
          align="right"
          icon="pi pi-times"
          className="p-button-danger"
          style={{ background: "red" }}
          onClick={() => {
            this.removeAcceptedProperty(rowData.value);
          }}
        />
      </div>
    );
  };
}
// TODO dropdown fix
// addAcceptedProperty = () => {
//     var property = this.state.currentAcceptedProperty;
//     var currentList = this.state.editedAttributeSet.attributeIdList;
//     if (currentList === undefined || currentList === null) {
//       currentList = [];
//     }

//     currentList.push(property);
//     this.logger.info(currentList);
//     this.updateBean("attributeIdList", currentList);
//     this.setState({ currentAcceptedProperty: "" });
//     var newAttributes = [];
//     var attributes = this.state.attributeOptions;
//     var removedAttributeOptions = this.state.removedAttributeOptions;
//     if (
//       removedAttributeOptions === undefined ||
//       removedAttributeOptions === null
//     ) {
//       removedAttributeOptions = [];
//     }
//     this.logger.info(property);
//     this.logger.info(attributes);
//     attributes.forEach(e => {
//       if (e.value === property) {
//         removedAttributeOptions.push(e);
//       } else {
//         newAttributes.push(e);
//       }
//     });

//     this.setState({ attributeOptions: newAttributes });
//   };
//   removeAcceptedProperty = value => {
//     var currentList = this.state.editedAttributeSet.attributeIdList;
//     this.logger.info(currentList);
//     if (currentList === undefined || currentList === null) {
//       currentList = [];
//     } else {
//       this.logger.info(value);
//       currentList = currentList.filter(item => item !== value);
//     }
//     var currentAttributes = this.state.attributeOptions;
//     if (currentAttributes === undefined || currentAttributes === null) {
//       currentAttributes = [];
//     }
//     var removedAttributes = this.state.removedAttributeOptions;
//     if (removedAttributes === undefined || removedAttributes === null) {
//       removedAttributes = [];
//     }
//     var newRemovedAttributes = [];
//     removedAttributes.forEach(e => {
//       if (e.value === value) {
//         currentAttributes.push(e);
//       } else {
//         newRemovedAttributes.push(e);
//       }
//     });

//     this.logger.info(currentList);
//     this.updateBean("attributeIdList", currentList);
//     this.setState({ currentAcceptedProperty: "" });

//     this.setState({ attributeOptions: currentAttributes });
//     this.setState({ removedAttributeOptions: newRemovedAttributes });
//   };



// WEBPACK FOOTER //
// ./src/components/Common/ListValueGenerator.js